module.exports = {
      id: "album-usage",
      viewBox: "0 0 25.602 21.762",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#album",
      toString: function () {
        return this.url;
      }
    }